import { useEffect, useState } from 'react'
import { bridge } from '~/services/bridge'

const COMPACT_VIEWPORT_MAX_WIDTH = 520

const getIsCompactViewport = () => {
  if (bridge.isInPlugin()) return true
  if (typeof window === 'undefined') return false
  return window.innerWidth <= COMPACT_VIEWPORT_MAX_WIDTH
}

export function useCompactViewport() {
  const [isCompactViewport, setIsCompactViewport] = useState<boolean>(getIsCompactViewport)

  useEffect(() => {
    const handleResize = () => {
      setIsCompactViewport(getIsCompactViewport())
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return isCompactViewport
}
